module.exports = __webpack_public_path__ + "assets/img/simplybrand-metrics-jp.43e9de72.png";